<template>
  <div class="dict">
    <div class="addCooperation">
      <!-- tab页 -->
      <el-tabs class="addCooperationTabs" type="border-card">
        <!-- 仓储信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.warehouseInfo')">
          <el-form :model="formData" :rules="rules" ref="formData" label-width="90px">
            <el-collapse v-model="activeNames" class="collapse-main-content">
              <el-collapse-item v-if="contractStatus == 'ZT03'" name="3">
                <template slot="title">
                  <div class="collapse-title-pre"
                    ><span></span>{{ this.$t('warehouseContract.form.editTitle') }}</div
                  >
                </template>
                <div class="collapse-content">
                  <el-form-item prop="editReason" :label="$t('warehouseContract.form.editTitle')">
                    <el-input
                      v-model="formData.editReason"
                      :placeholder="$t('warehouseContract.form.editResonPlaceholder')"
                      type="textarea"
                      clearable
                      maxlength="256"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-collapse-item>
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="collapse-title-pre"
                    ><span></span>{{ this.$t('warehouseContract.form.basicInfo') }}</div
                  >
                </template>
                <div class="collapse-content">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractEnterpriseNo"
                        :label="this.$t('warehouseContract.form.contractEnterpriseNo')"
                      >
                        <search-table
                          v-model="formData.contractEnterpriseNo"
                          searchType="partner"
                          :isMultiple="true"
                          :disabled="canNotEdit"
                          :checkRowKeys="[formData.contractEnterpriseNo] || []"
                          :currentValue="formData.contractEnterpriseName"
                          propName="storageName"
                          propCode="storageCode"
                          :placeholder="
                            $t('warehouseContract.form.contractEnterpriseNoPlaceholder')
                          "
                          :extraData="{
                            partnerTypes: 'HZHB07,HZHB02,HZHB03',
                          }"
                          @input="setWarehouseIn"
                        ></search-table>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="registeredAssets"
                        :label="this.$t('warehouseContract.form.registeredAssets')"
                      >
                        <input-number-ad
                          style="width: 100%"
                          v-model="formData.registeredAssets"
                          :disabled="canNotEdit"
                          :controls="false"
                          max="99999999999.999999"
                          :placeholder="
                            this.$t('warehouseContract.form.registeredAssetsPlaceholder')
                          "
                        >
                        </input-number-ad>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contactPersonNo"
                        :label="this.$t('warehouseContract.form.contactPersonNo')"
                      >
                        <el-input
                          v-model="formData.contactPersonNo"
                          :disabled="canNotEdit"
                          :placeholder="
                            this.$t('warehouseContract.form.contactPersonNoPlaceholder')
                          "
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contactPhone"
                        :label="this.$t('warehouseContract.form.contactPhone')"
                      >
                        <el-input
                          v-model="formData.contactPhone"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.contactPhonePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="signDate"
                        :label="this.$t('warehouseContract.form.signDate')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.signDate"
                          :disabled="canNotEdit"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :placeholder="this.$t('warehouseContract.form.signDatePlaceholder')"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="valideDateTo"
                        :label="this.$t('warehouseContract.form.valideDateTo')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.valideDateTo"
                          :disabled="canNotEdit"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :placeholder="this.$t('warehouseContract.form.valideDateToPlaceholder')"
                          clearable
                        >
                        </el-date-picker>
                        <!-- <el-input v-model="formData.valideDateTo"  :disabled="canNotEdit"
                                                :placeholder='this.$t("warehouseContract.form.valideDateToPlaceholder")'>
                                            </el-input> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="goodsControlAmount"
                        :label="this.$t('warehouseContract.form.goodsControlAmount')"
                      >
                        <input-number-ad
                          style="width: 100%"
                          v-model="formData.goodsControlAmount"
                          :disabled="canNotEdit"
                          :controls="false"
                          max="99999999999.999999"
                          :placeholder="
                            this.$t('warehouseContract.form.goodsControlAmountPlaceholder')
                          "
                        >
                        </input-number-ad>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="productCategory"
                        :label="this.$t('warehouseContract.form.productCategory')"
                      >
                        <SearchModal
                          className="customer-search"
                          v-if="canNotEdit == false"
                          ref="searchModal"
                          :propName="goods.propName"
                          :propCode="goods.propCode"
                          model="productName"
                          :placeholder="$t('warehouseContract.form.productCategoryPlaceholder')"
                          :API="goods.API"
                          :query="goods.query"
                          :page="goods.page"
                          :searchColumns="goods.searchColumns"
                          :columnList="goods.columnList"
                          :isMultiple="true"
                          :currentValue="formData.productCategory"
                          @setSearchModal="setProduct"
                        ></SearchModal>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="feature"
                        :label="this.$t('warehouseContract.form.feature')"
                      >
                        <el-input
                          v-model="formData.feature"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.featurePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractVenue"
                        :label="this.$t('warehouseContract.form.contractVenue')"
                      >
                        <el-input
                          v-model="formData.contractVenue"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.contractVenuePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="chargeStandard"
                        :label="this.$t('warehouseContract.form.chargeStandard')"
                      >
                        <el-input
                          v-model="formData.chargeStandard"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.chargeStandardPlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="collapse-title-pre"
                    ><span></span>{{ this.$t('warehouseContract.form.systemInfo') }}</div
                  >
                </template>
                <div class="collapse-content">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractCompanyName"
                        :label="this.$t('warehouseContract.form.contractCompanyNo')"
                      >
                        <el-input
                          v-model="formData.contractCompanyName"
                          :disabled="true"
                          :placeholder="
                            this.$t('warehouseContract.form.contractCompanyNoPlaceholder')
                          "
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractCreatePersonName"
                        :label="this.$t('warehouseContract.form.contractCreatePersonNo')"
                      >
                        <el-input
                          v-model="formData.contractCreatePersonName"
                          :disabled="true"
                          :placeholder="
                            this.$t('warehouseContract.form.contractCreatePersonNoPlaceholder')
                          "
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6">
                      <el-form-item
                        prop="contractCreateDate"
                        :label="this.$t('warehouseContract.form.contractCreateDate')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.contractCreateDate"
                          :disabled="true"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :placeholder="
                            this.$t('warehouseContract.form.contractCreateDatePlaceholder')
                          "
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractMark"
                        :label="this.$t('warehouseContract.form.contractMark')"
                      >
                        <el-input
                          v-model="formData.contractMark"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.contractMarkPlaceholder')"
                          clearable
                          maxlength="126"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </el-tab-pane>
        <!-- 附件信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.attachmentInfo')">
          <upload
            ref="upload"
            defaultPath="scm/warehouseContract"
            :tableData="attachmentList"
            @upload="uploadList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="isEdit == false || contractStatus == 'ZT06'"
        type="primary"
        @click="save"
        v-hasPermi="['2021050814522177311']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        type="primary"
        @click="commit"
        :loading="load"
        v-hasPermi="['2021050814514974918']"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.commit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import API from '@/api/logisticsCenter/warehouseContract.js';
  import DataBaseAPI from '@/api/dataBase';
  import upload from '@/components/upload';
  import formRules from './rules/rules';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import searchTable from '@/components/form-item/search-table';

  export default {
    components: {
      SearchModal,
      upload,
      inputNumberAd,
      searchTable,
    },
    name: 'logisticsContractBaseEdit',
    data() {
      let newDate = new Date();
      let canNotEdit = this.$route.query.canNotEdit == '0' ? true : false;
      return {
        contractStatus: '',
        contractType: '02',
        contractNo: null,
        // isEdit:false,
        canNotEdit: canNotEdit,
        isEdit: !canNotEdit,
        load: false,
        attachmentList: [], //附件列表
        activeNames: ['1', '2', '3', '4', '5', '6', '7'], //默认展开那些面板，
        formData: {
          contractCreateDate: newDate, //申请时间
          contractCreatePersonNo: '',
          contractCreatePersonName: '',
          contractCompanyName: '',
          contractCompanyNo: '',
          contractEnterpriseNo: '',
          contractEnterpriseName: '',
          stationName: '物产',
          productCategory: '',
          feature: '',
          storageAddress: '中国',
        },
        rules: formRules.formRules,
        productEditRules: formRules.productEditRules,
        warehouseEditRules: formRules.warehouseEditRules,
        numberObj: {
          max: 999999999999,
          precision: 2,
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //合作伙伴
      partner() {
        return {
          API: DataBaseAPI.PARTNER_LIST_API,
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          query: {
            requestStatus: 'ZT03',
            partnerType: 'HZHB07',
            //adminFlag: this.userInfo.userInfo.adminFlag,
          },
          searchColumns: [
            {
              name: window.vm.$t('cooperation.label.partnerZhName'),
              prop: 'partnerZhName',
              type: 'input',
            },
          ],
          columnList: [
            { prop: 'partnerZhName', label: window.vm.$t('cooperation.label.partnerZhName') },
            { prop: 'partnerCode', label: window.vm.$t('cooperation.label.partnerCode') },
            { prop: 'identityNo', label: window.vm.$t('cooperation.label.identityNo') },
            { prop: 'creditCode', label: window.vm.$t('cooperation.label.creditCode') },
            { prop: 'requestByName', label: window.vm.$t('cooperation.label.requestByName') },
            { prop: 'requestTime', label: window.vm.$t('cooperation.label.requestTime') },
            //   { prop: "requestStatus", label: window.vm.$t('cooperation.label.requestStatus') },
          ],
        };
      },

      //商品子类
      goods() {
        return {
          width: '800',
          query: {
            detailProductDisplayName: null,
            productDetailCode: null,
          },
          API: DataBaseAPI.LIST_DETAIL_PRODUCT,
          extraData: {
            //已生效
            detailProductStatus: 'ZT03',
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propCode: 'productDetailCode',
          propName: 'detailProductDisplayName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: window.vm.$t('goods.search.productDetailCode'),
              type: 'input',
              placeholder: '请输入',
            },
            {
              name: window.vm.$t('goods.search.detailProductDisplayName'),
              prop: 'detailProductDisplayName',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: window.vm.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'detailProductDisplayName',
              label: window.vm.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductModel',
              label: window.vm.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
    },
    mounted() {
      this.userInfo.userInfo;
      this.version = this.$route.query.version;
      //控制页面是否可修改
      if (this.$route.query && this.$route.query.canEdit && this.$route.query.canEdit == '0') {
        this.canNotEdit = true;
      } else {
        this.canNotEdit = false;
      }
      this.contractNo = this.$route.query.contractNo || null;
      if (this.contractNo) {
        this.isEdit = true;
        this.getData();
      } else {
        this.isEdit = false;
        this.formData.contractCompanyName = this.userInfo.userInfo.companyName;
        this.formData.contractCompanyNo = this.userInfo.userInfo.companyCode;
        this.formData.contractCreatePersonName = this.userInfo.userInfo.userName;
        this.formData.contractCreatePersonNo = this.userInfo.userInfo.userCode;
        this.formData.contractUpdatePersonName = this.userInfo.userInfo.userName;
      }
      //this.getDic()
    },
    methods: {
      //选择商品
      setProduct(name, value) {
        if (value.length > 0) {
          this.formData.productCategory = value[0].detailProductDisplayName;
        }
      },
      //获取详情
      getData() {
        let params = {
          contractType: this.contractType,
          contractNo: this.contractNo,
        };
        this.$axios.get(API.DETAIL_CONTRACT__API, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.formData = res.data.data;
            this.contractStatus = this.formData.contractStatus;
            this.attachmentList = res.data.data.distributionAttachments;
            this.version = this.formData.version;
            this.$nextTick(() => {
              this.$refs.formData.clearValidate();
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //选择签约单位
      setWarehouseIn(value) {
        if (value.length > 0) {
          this.formData.contractEnterpriseNo = value[0].partnerCode;
          this.formData.contractEnterpriseName = value[0].partnerZhName;
        }
      },

      //获取字典值
      getDic() {
        //入库方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'enterprise_type',
            tenantCode: this.userInfo.userInfo.tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.enterpriseTypeList = res.data.data;
            }
          });
      },
      //保存/提交
      save() {
        this.saveData('ZT06');
      },
      //提交
      commit() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.saveData('ZT02');
          } else {
            //   console.log("12324335")
          }
        });
      },
      //调用保存方法
      saveData(status) {
        this.load = true;
        let data = this.formData;
        if (this.$route.query && this.$route.query.version) {
          data.version = this.version;
        }
        if (this.contractNo) {
          data.contractNo = this.contractNo;
        }
        data.contractStatus = status;
        data.contractType = this.contractType;
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        data.admin = this.userInfo.userInfo.adminFlag;
        data.contractUpdatePersonName = this.userInfo.userInfo.userName;
        //附件列表
        let list = [];
        if (this.attachmentList && this.attachmentList.length > 0) {
          this.attachmentList.map((item) => {
            let id = item._XID;
            let obj = {
              attachmentName: item.attachmentName,
              attachmentPath: item.attachmentPath,
              sortNo: id.substring(4, id.length),
              gmtCreate: item.gmtCreate,
              createBy: item.createBy,
            };
            if (item.attachmentId) {
              obj.attachmentId = item.attachmentId;
            }
            if (item.tenantCode) {
              obj.tenantCode = item.tenantCode;
            }
            if (item.companyCode) {
              obj.companyCode = item.companyCode;
            }
            if (item.departmentCode) {
              obj.departmentCode = item.departmentCode;
            }
            if (item.companyName) {
              obj.companyName = item.companyName;
            }
            if (item.departmentName) {
              obj.departmentName = item.departmentName;
            }
            list.push(obj);
          });
        }
        data.distributionContractStorages = JSON.stringify([]);
        data.distributionContractProducts = JSON.stringify([]);
        data.distributionAttachments = JSON.stringify(list);
        this.$axios.post(API.ADD_CONTRACT_API, data).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            if (status == 'ZT06') {
              if (this.$route.name == 'logisticsContractAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getData();
              }
            } else {
              this.toPath();
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/logistics/logisticsContractAdd',
            name: 'logisticsContractAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/logisticsContractDetail',
            name: 'logisticsContractDetail',
            meta: {
              keepAlive: false,
            },
            query: { contractNo: value.contractNo, canEdit: '0' },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      toPath() {
        let path = {
          fromPath: {
            path: '/logistics/logisticsContractAdd',
            name: 'logisticsContractAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/logisticsContractList',
            name: 'logisticsContractList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //更新附件列表
      uploadList(value) {
        this.attachmentList = value;
      },
    },
    watch: {},
  };
</script>
